import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Multi } from "../../../interfaces/multi.interface";
import { NgxMultiNameFunc } from "../multi-name-func/multi-name-func.operator";


export function NgxMultiNameTemplate(nameTemplate: String = null): OperatorFunction<Multi[], Multi[]> {

  var nameFunc = new Function(`return \`${nameTemplate}\`;`);

  return NgxMultiNameFunc(multi => nameFunc.call(multi.series[0].data));
}

